/**
 * Use home page route refresh.
 *
 * Explains routing behavior, guards, and response semantics.
 */
import { useEffect } from 'react'
import type { Route } from '../../types'

type Params = {
  routeMode: Route['mode']
  homepageSlug: string
  loadHomePage: (slug: string) => Promise<void>
}

/**
 * Use home page route refresh.
 *
 * Explains routing behavior, guards, and response semantics.
 */
export const useHomePageRouteRefresh = ({ routeMode, homepageSlug, loadHomePage }: Params) => {
  useEffect(() => {
    if (routeMode !== 'home') return
    void loadHomePage(homepageSlug)
  }, [homepageSlug, loadHomePage, routeMode])
}
